import {FmlxBackdropLoading} from "fmlx-common-ui";

const BackdropLoading = () => (
  <FmlxBackdropLoading
    show description={null}
    showButton={false}
  />
);

export default BackdropLoading;